import React, { useState } from 'react'
import { HelpCircle } from 'lucide-react'
import SupportGuideManualModal from './SupportGuideManualModal'
import { Button } from './ui/button'

/** 가이드(?) 버튼 전역 표시 여부. 매뉴얼 이미지 조정 중에는 false로 두고 완료 후 true로 복구 */
const MENU_GUIDE_BUTTON_VISIBLE = false

export default function MenuGuideButton({ slug, title, label = '가이드', anchor = '' }) {
  const [open, setOpen] = useState(false)
  const accessibleLabel = `${label} 보기`
  if (!MENU_GUIDE_BUTTON_VISIBLE) return null
  if (!slug) return null

  return (
    <>
      <Button
        type="button"
        variant="sgezOutline"
        size="icon"
        className="h-7 w-7 shrink-0 rounded-full p-0 text-slate-500 shadow-none hover:border-brand-sky hover:bg-sky-50 hover:text-brand-sky"
        aria-label={accessibleLabel}
        title={accessibleLabel}
        onClick={() => setOpen(true)}
      >
        <HelpCircle className="h-4 w-4" aria-hidden="true" />
      </Button>
      <SupportGuideManualModal
        open={open}
        title={title || label}
        slug={slug}
        anchor={anchor}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
